<template>
    <VueSlickCarousel v-bind="configCarousel" v-if="ready">
        <a :href="anexo.url" target="_blank" class="item-anexo" v-for="(anexo, idAnexo) in anexos" :key="idAnexo">
            <div class="imagem-anexo w-100 h-100 borda-redonda sombra" v-bind:style="{ backgroundImage: `url(${anexo.url})` }" v-if="ehImagem(anexo.url)"></div>
            <i v-else class="far fa-file fa-5x"></i>
        </a>
    </VueSlickCarousel>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

export default {
    data() {
        return {
            ready: true,
            configCarousel: {
                "dots": true,
                "infinite": false,
                "speed": 500,
                "slidesToShow": 4,
                "slidesToScroll": 2
            }
        }
    },
    components: { VueSlickCarousel },
    props: {
        anexos: [Object, Array],
    },
    methods: {
        ehImagem(urlArquivo) {
            const ext = urlArquivo.split('.').pop();
            return (['jpg', 'jpeg', 'png', 'jfif', 'bmp', 'gif'].indexOf(ext) > -1);
        }
    },
    watch: {
        anexos() {
            this.ready = false;
            setTimeout(() => {
                this.ready = true;
            }, 100);
        }
    }
}
</script>

<style>
    .item-anexo {
        height: 150px !important;
        width: 90px !important;
        padding: 0.5rem !important;
    }
    .imagem-anexo{
        background-size: cover;
        background-position: center
    }
    .slick-next:before,
    .slick-prev:before {
        color:#789;
    }
</style>